import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from '@app/i18n/services';
import { FeedbackService } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { slideInOutAnimation } from '@shared/animations';
import { finalize } from 'rxjs/operators';
import { environment } from '@env/environment';
import { TokenService } from '@services/token';
import { AuthService } from '@services/auth';
import { routePathName } from '@app/app.models';

@Component({
	templateUrl: './callback.component.html',
	animations: [slideInOutAnimation]
})
export class OAuthCallbackComponent implements OnInit {
	@HostBinding('@slideInOutAnimation')
	private code: string;
	private state: string;

	constructor(
		private activeRoute: ActivatedRoute,
		private tokenService: TokenService,
		private authService: AuthService,
		private feedbackService: FeedbackService,
		private progressIndicatorService: ProgressIndicatorService,
		private i18nService: I18nService
	) {}

	public ngOnInit() {
		this.progressIndicatorService.spinner(true);
		this.getQueryParams();
	}

	private getQueryParams() {
		this.activeRoute.queryParams.subscribe((params) => {
			this.code = params?.code;
			this.state = params?.state;

			if (this.code) {
				this.getAccessToken(this.code);
			} else {
				this.progressIndicatorService.spinner(false);
				this.navigate("/" + routePathName.signIn);
			}
		});
	}

	private getAccessToken(code: string) {
		this.tokenService
			.getAccessToken(code)
			.pipe(finalize(() => this.progressIndicatorService.spinner(false)))
			.subscribe(
				() => {
					const url = this.authService.returnUrl ?? environment.apps.portal;
					this.authService.returnUrl = null;
					this.navigate(url);
				},
				(error: any) => {
					this.feedbackService.apiError(
						error,
						this.i18nService.get('There was an error logging you in.', 'app.api.response.login-error')
					);

					this.navigate("/" + routePathName.signIn);
				}
			);
	}

	private navigate(url: string): void {
		window.location.assign(url);
	}
}
